import { Select } from '@doordash/component-fields'
import { Icon } from '@doordash/design-language'
import styled from 'styled-components'

type StyleProps = {
  size: string
  type: string
  accessibilityDescribedBy: string
  isRounded: boolean
}

export const GlobeIcon = styled(Icon).attrs<StyleProps>({
  type: Icon.Types.GlobeLine,
})`
  display: flex;
`

export const LanguageSelectWrapper = styled.div`
  width: 190px;
`

export const LanguageSelect = styled(Select).attrs<StyleProps>({
  size: Select.Sizes.Small,
  accessibilityDescribedBy: 'Change Language',
  isRounded: true,
})``
